import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "fixed inset-0 z-[200] flex items-center justify-center overflow-auto vue-modal-background tw at-update-rate-group",
  style: {
    "z-index": "100"
  }
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  class: "py-2"
};
const _hoisted_4 = {
  class: "flex justify-between w-full gap-4 py-2"
};
const _hoisted_5 = {
  class: "w-full"
};
const _hoisted_6 = {
  class: "w-full"
};
const _hoisted_7 = {
  class: "w-full"
};
const _hoisted_8 = {
  class: "w-full"
};
const _hoisted_9 = {
  class: "w-full"
};
const _hoisted_10 = {
  class: "py-2"
};
const _hoisted_11 = {
  class: "flex justify-between w-full gap-4 py-2"
};
const _hoisted_12 = {
  class: "w-full"
};
const _hoisted_13 = {
  class: "w-full"
};
const _hoisted_14 = {
  class: "flex justify-between w-full gap-4 py-2"
};
const _hoisted_15 = {
  class: "w-full"
};
const _hoisted_16 = {
  class: "w-full"
};
import { reactive, onMounted } from 'vue';
import RouteService from '@/services/RouteService';
import useClientMatterStore from '@/services/useClientMatterStore';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';

// Component Imports
import Loader from '@/components/Loader.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlTextarea from '@/components/LlTextarea.vue';
export default {
  __name: 'UpdateClientBillingAddressModal',
  props: {
    stateParams: Object,
    state: Object,
    rootScope: Object
  },
  setup(__props) {
    const props = __props;
    const clientMatterStore = useClientMatterStore();
    const routeService = new RouteService(props);
    const {
      handleError
    } = useSnackbarHandler();
    const clientAddressUpdateState = reactive({
      loading: false,
      error: null,
      success: null,
      groupInvoicePdf: false,
      clientInfo: {
        clientId: '',
        companyName: '',
        contact: {
          title: '',
          firstName: '',
          middleName: '',
          lastName: '',
          suffix: ''
        },
        address: {
          email: '',
          nameAndStreet: '',
          city: '',
          zip: '',
          state: '',
          country: '',
          formatted: ''
        }
      }
    });
    onMounted(() => {
      loadClient();
    });
    function isActiveClientRoute(expectedClientId) {
      return String(props.stateParams?.id) === String(expectedClientId);
    }
    function loadClient() {
      const requestedClientId = props.stateParams?.id;
      if (!requestedClientId) {
        return Promise.resolve();
      }
      clientAddressUpdateState.loading = true;
      clientAddressUpdateState.groupInvoicePdf = props.stateParams.option?.actions?.groupInvoicePdf || false;
      return clientMatterStore.getClientById(requestedClientId).then(client => {
        // Ignore stale responses if the user switched clients while this request was in flight.
        if (!isActiveClientRoute(requestedClientId)) {
          return;
        }
        clientAddressUpdateState.clientInfo = hydrateForm(client);
        clientAddressUpdateState.loading = false;
      }).catch(err => {
        clientAddressUpdateState.loading = false;
        handleError(err);
      });
    }
    const hydrateForm = client => {
      return {
        clientId: client.id,
        companyName: client.contact?.companyName,
        contact: {
          title: client.contact?.title,
          firstName: client.contact?.first,
          middleName: client.contact?.middle,
          lastName: client.contact?.last,
          suffix: client.contact?.suffix
        },
        address: {
          email: client.contact?.email,
          nameAndStreet: client.contact?.address?.address,
          city: client.contact?.address?.city,
          zip: client.contact?.address?.zip,
          state: client.contact?.address?.state,
          country: client.contact?.address?.country,
          formatted: client.contact?.address?.formatted
        }
      };
    };
    const handleCloseButton = () => {
      routeService.go('^');
    };
    const prepareToSend = () => {
      if (clientAddressUpdateState.groupInvoicePdf) {
        props.rootScope.processGroupInvoicePdf({
          clientInfo: clientAddressUpdateState.clientInfo
        });
        routeService.go('^');
        return;
      }
      routeService.go(`billing.review.${props.stateParams.invoiceState}.emailCustomization`, {
        option: props.stateParams.option,
        invoices: props.stateParams.invoices,
        clientInfo: clientAddressUpdateState.clientInfo
      });
    };
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_container = _resolveComponent("v-container");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "bg-gray-50 shadow-lg rounded-sm",
        onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["prevent"])),
        style: {
          "width": "800px",
          "height": "auto",
          "max-width": "100%",
          "max-height": "95vh",
          "overflow-y": "auto"
        }
      }, [clientAddressUpdateState.loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: 'Client Address',
        class: "my-16 px-6"
      })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_v_card, {
        title: "Client Address",
        class: "px-4 pt-4"
      }, {
        append: _withCtx(() => [_createVNode(_component_v_icon, {
          onClick: _cache[0] || (_cache[0] = $event => handleCloseButton())
        }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("mdi-close", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [_cache[17] || (_cache[17] = _createElementVNode("div", {
            class: "py-2 pr-10"
          }, " Update the fields below to override the client address on the cover page. This change will not affect individual matter-level invoices. ", -1)), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_3, [_createVNode(LlTextField, {
            modelValue: clientAddressUpdateState.clientInfo.companyName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => clientAddressUpdateState.clientInfo.companyName = $event),
            label: "Company Name"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(LlTextField, {
            modelValue: clientAddressUpdateState.clientInfo.contact.title,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => clientAddressUpdateState.clientInfo.contact.title = $event),
            label: "Title"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_createVNode(LlTextField, {
            modelValue: clientAddressUpdateState.clientInfo.contact.firstName,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => clientAddressUpdateState.clientInfo.contact.firstName = $event),
            label: "First Name"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_7, [_createVNode(LlTextField, {
            modelValue: clientAddressUpdateState.clientInfo.contact.middleName,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => clientAddressUpdateState.clientInfo.contact.middleName = $event),
            label: "Middle Name"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_8, [_createVNode(LlTextField, {
            modelValue: clientAddressUpdateState.clientInfo.contact.lastName,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => clientAddressUpdateState.clientInfo.contact.lastName = $event),
            label: "Last Name"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_9, [_createVNode(LlTextField, {
            modelValue: clientAddressUpdateState.clientInfo.contact.suffix,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => clientAddressUpdateState.clientInfo.contact.suffix = $event),
            label: "Suffix"
          }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_10, [_createVNode(LlTextarea, {
            modelValue: clientAddressUpdateState.clientInfo.address.nameAndStreet,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => clientAddressUpdateState.clientInfo.address.nameAndStreet = $event),
            label: "Invoicing Address"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(LlTextField, {
            modelValue: clientAddressUpdateState.clientInfo.address.city,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => clientAddressUpdateState.clientInfo.address.city = $event),
            label: "City"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_13, [_createVNode(LlTextField, {
            modelValue: clientAddressUpdateState.clientInfo.address.state,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => clientAddressUpdateState.clientInfo.address.state = $event),
            label: "State"
          }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(LlTextField, {
            modelValue: clientAddressUpdateState.clientInfo.address.zip,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => clientAddressUpdateState.clientInfo.address.zip = $event),
            label: "Zip"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_16, [_createVNode(LlTextField, {
            modelValue: clientAddressUpdateState.clientInfo.address.country,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => clientAddressUpdateState.clientInfo.address.country = $event),
            label: "Country"
          }, null, 8, ["modelValue"])])])]), _createElementVNode("div", null, [_createVNode(_component_v_container, null, {
            default: _withCtx(() => [_createVNode(_component_v_row, {
              justify: "end",
              align: "end"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                cols: "auto"
              }, {
                default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                  onClick: _cache[12] || (_cache[12] = _withModifiers($event => handleCloseButton(), ["prevent"]))
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode(" Cancel ", -1)]))]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_col, {
                cols: "auto",
                class: "at-send-email"
              }, {
                default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                  variant: "flat",
                  color: "primary",
                  id: "at-send-email",
                  "data-cy": "send-email",
                  onClick: _cache[13] || (_cache[13] = _withModifiers($event => prepareToSend(), ["prevent"]))
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(clientAddressUpdateState.groupInvoicePdf ? 'Print Invoice Group' : 'Email Invoice Group'), 1)]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      })]))])]);
    };
  }
};